import { useTranslation } from "react-i18next";
import { Icon } from "@/atoms/icon";

/**
 * The one line under the Pay button.
 *
 * Where the money actually goes, in four words and a 16 lock, centred at 13 tertiary. It is the
 * quietest thing on the page on purpose: the loudest is the button above it, and a badge, a
 * shield or a row of reassurances would be three more voices arguing with it.
 *
 * Stripe is named here and nowhere else on the page.
 *
 * The glyph is 16 and not 14: 16 is the smallest step of the icon scale and gate 7.2 measures it.
 */

export function StripeLine() {
  const { t } = useTranslation();
  return (
    <p className="gap-gk-2 flex items-center justify-center text-center text-[13px] text-[var(--gk-text-tertiary)]">
      <Icon name="lock" size={16} style={{ flexShrink: 0 }} />
      <span>{t("gymkeePay.common.securedByStripe")}</span>
    </p>
  );
}
